import {createAsyncThunk, createSlice, isAnyOf, PayloadAction} from '@reduxjs/toolkit';
import {IUserState} from "../../../../interface/Passport/Account/frontend";
import {
    IConfirmCodeProps,
    IConfirmCodeResult,
    IInitiateDataChangeProps, IInitiateDataChangeResult,
    InitiateDataChangeResultModel,
    ISetNewPhoneProps,
    ISetNewPhoneResult,
} from "../../../../interface/Passport/Account/backend";
import {IErrorResult, IServerError} from "../../../../interface/Basic/api";
import {confirmCode, initiateChangeData, setNewPhone} from "../api/api";

export const SetNewPhone = createAsyncThunk<ISetNewPhoneResult, ISetNewPhoneProps, { rejectValue: IErrorResult }>
('SetNewPhone', (data, thunkAPI) => setNewPhone(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const InitiateChangeData = createAsyncThunk<IInitiateDataChangeResult, IInitiateDataChangeProps, {
    rejectValue: IErrorResult
}>
('initiateChangeData', (data, thunkAPI) => initiateChangeData(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const ConfirmCode = createAsyncThunk<IConfirmCodeResult, IConfirmCodeProps, { rejectValue: IErrorResult }>
    ('ConfirmCode', (data, thunkAPI) => confirmCode(data)
        .then(resolve => resolve)
        .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))
    

const initialState: IUserState = {
    error: {},
    isFetching: false,
    setChangeSuccess: false,
    setSmsPend: false,
    setChangeDataForChange: null,
}
export const slice = createSlice({
    name: 'user',
    initialState,
    reducers:
        {
            addErrorEnter(state, action: PayloadAction<{ key: string, value: string }>) {
                state.error[action.payload.key] = action.payload.value
            },
            cleanErrorEnter(state, action: PayloadAction<string>) {
                delete state.error[action.payload]
            },
            setChangeSuccessFalse(state){
                state.setChangeSuccess=false
            },
            setChangeDataForChangeNull(state){
                state.setChangeDataForChange=null
            }
        },
    extraReducers:(builder)=>{
        builder.addCase(SetNewPhone.fulfilled, (state) => {
            state.setChangeSuccess=true;
            state.isFetching=false;
        })
        builder.addCase(SetNewPhone.pending, (state) => {
            state.isFetching=true;
        })

        builder.addCase(InitiateChangeData.fulfilled, (state, action) => {
            state.setChangeDataForChange=InitiateDataChangeResultModel.parse(action.payload.data);
            state.isFetching=false;
        })
        builder.addCase(ConfirmCode.fulfilled, (state) => {
            state.setChangeSuccess=true;
        })

        builder.addMatcher(isAnyOf(
            InitiateChangeData.pending,
        ), (state) => {
            state.setSmsPend=true;
            state.isFetching=true;
        })

        builder.addMatcher(isAnyOf(
            InitiateChangeData.fulfilled,
        ), (state) => {
            state.setSmsPend=false;
            state.isFetching=false;
        })
        builder.addMatcher(isAnyOf(
            InitiateChangeData.rejected,
            SetNewPhone.rejected,
            ConfirmCode.rejected,
        ), (state, action) => {
            if (action.payload?.fields) {
                Object.entries(action.payload.fields).forEach((item) => {
                    state.error[item[0]] = item[1] ? item[1][0] : ''
                })
            }
            state.isFetching=false;
        })
    }
})

export const {
    addErrorEnter,
    cleanErrorEnter,
    setChangeSuccessFalse,
    setChangeDataForChangeNull
} = slice.actions;

export default slice.reducer;
